<script setup lang="ts">
/**
 * Questions-réponses dépliables. Une seule ouverte à la fois ; le « + » pivote en « × ».
 * Chaque question est une carte délimitée par un filet, sans ombre.
 */
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from 'reka-ui'

import Icon from './Icon.vue'

defineProps<{ items: readonly { question: string; answer: string }[]; numbered?: boolean }>()
</script>

<template>
  <AccordionRoot type="single" collapsible default-value="0" class="flex flex-col gap-3">
    <AccordionItem
      v-for="(item, index) in items"
      :key="item.question"
      :value="String(index)"
      class="rounded-control border border-line bg-bg transition-colors duration-160 data-[state=open]:border-accent"
    >
      <AccordionHeader>
        <AccordionTrigger
          class="group flex min-h-touch w-full items-center gap-4 px-5 py-4 text-left text-section text-ink"
        >
          <span class="flex-1">
            <template v-if="numbered">{{ index + 1 }}. </template>{{ item.question }}
          </span>
          <span
            class="flex size-8 shrink-0 items-center justify-center rounded-full bg-surface text-ink transition-transform duration-240 ease-standard group-data-[state=open]:rotate-45 group-data-[state=open]:bg-accent-strong group-data-[state=open]:text-ink-inverse"
            aria-hidden="true"
          >
            <Icon name="add" :size="16" />
          </span>
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent
        class="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
      >
        <p class="px-5 pb-5 text-body text-ink-muted">{{ item.answer }}</p>
      </AccordionContent>
    </AccordionItem>
  </AccordionRoot>
</template>
